import styled from 'styled-components'

enum ProgressColors {
  HIGH = '#41b53a',
  LOW = '#ce3434',
  MEDIUM = '#e4d444'
}

const WarpTitleNps = styled.div`
  font-weight: bold;
  text-align: center;
`

const WrapNpsTop = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

const WrapPeriod = styled.div`
  font-size: small;
`

const WrapSectionHeader = styled.div`
  margin-bottom: 1rem;
  min-height: 5rem;
  #title {
    text-decoration-line: underline;
  }
  #header {
    font-weight: bold;
  }
  #value {
    font-weight: 100;
  }
`

export {
  ProgressColors,
  WarpTitleNps,
  WrapNpsTop,
  WrapPeriod,
  WrapSectionHeader
}
